export default __webpack_public_path__ + "static/kyubu_fukubu_taibu-3b3b51b03d5f203cfb62513b6bdd6569.pdf";